// import { AmethystImg } from '../../assets';
import { colors } from '../../styles';
import { InfoLeagueProps } from '../leagues.props';
import { Amethyst } from './Amethyst';

export const AmethystLeague: InfoLeagueProps = {
  id: `${process.env.REACT_APP_ID_LEAGUE_AMETHYST}`,
  name: 'Amatista',
  description: 'Compite por el botín imperial.',
  icon: '💎',
  active: true,
  color: colors['league-amethyst-color'],
  bgColor: colors['league-amethyst-bg'],
  borderColor: colors['league-amethyst-border'],
  path: '/amethyst',
  page: Amethyst,
  // icon: AmethystImg,
};
